export const translations = {
  es: {
    nav: { home: 'Inicio', services: 'Servicios', about: 'Nosotros', employment: 'Empleo', contact: 'Contacto' },
    hero: {
      title: 'Infraestructura de Telecomunicaciones de Vanguardia',
      subtitle: 'Conectamos el futuro con soluciones integrales en canalizaciones, ductos y fibra óptica para redes de telecomunicaciones.',
      cta: 'Agendar una reunión',
      team: 'Equipo experto',
      teamDesc: 'Ingenieros y técnicos especializados',
      projects: 'Proyectos entregados en plazo',
      coverage: 'Países de operación'
    },
    about: {
      title: 'Sobre ENAUSA',
      subtitle: 'Líderes en Infraestructura de Telecomunicaciones',
      description: 'ENAUSA se ha consolidado como una empresa líder en la construcción y mantenimiento de infraestructura de telecomunicaciones en Argentina, España y Alemania.',
      mission: 'Nuestra Misión',
      missionText: 'Proporcionar soluciones integrales de infraestructura que permitan la expansión y modernización de las redes de telecomunicaciones.',
      values: 'Nuestros Valores',
      valuesList: {
        one: { title: 'Calidad Garantizada', description: 'Cumplimiento de las más altas normas de seguridad e higiene en todos nuestros proyectos.' },
        two: { title: 'Experiencia Comprobada', description: 'Años de experiencia en proyectos de infraestructura de telecomunicaciones a gran escala.' },
        three: { title: 'Tecnología Avanzada', description: 'Utilizamos equipos y técnicas de última generación para garantizar resultados óptimos.' },
        four: { title: 'Compromiso Ambiental', description: 'Protocolos ambientales estrictos para minimizar el impacto durante y después de la obra.' }
      },
      process: {
        title: 'Nuestro Proceso de Trabajo',
        subtitle: 'Un enfoque sistemático y profesional para garantizar la excelencia en cada proyecto',
        steps: {
          s1: { title: 'Análisis y Planificación', desc: 'Topografía y estudios de suelo' },
          s2: { title: 'Permisos y Coordinación', desc: 'Gestión con municipios y entes' },
          s3: { title: 'Ejecución de Obra', desc: 'Construcción con estándares de calidad' },
          s4: { title: 'Control de Calidad', desc: 'Verificación y pruebas exhaustivas' },
          s5: { title: 'Mantenimiento', desc: 'Soporte continuo y preventivo' }
        }
      }
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones Integrales en Telecomunicaciones',
      infrastructure: { title: 'Infraestructura de Canalización', description: 'Excavación y apertura de zanjas para ductos subterráneos.' },
      installation: { title: 'Instalación y Tendido', description: 'Instalación profesional de ductos y tendido de fibra óptica.' },
      maintenance: { title: 'Servicios Técnicos Especializados', description: 'Servicios avanzados para instalaciones complejas.' },
      permits: { title: 'Reposición y Restauración', description: 'Restauración de superficies posterior a instalaciones.' },
      features1: [
        'Zanja en adoquín',
        'Zanja en aglomerado acera', 
        'Zanja en aglomerado calzada',
        'Zanja en tierra',
        'Zanja en pavimento histórico',
        'Apertura de zanjas para ductos subterráneos',
        'Instalación de cámaras de inspección'
      ],
      features2: [
        'Instalación de ductos de alta capacidad',
        'Tendido de cables de fibra óptica',
        'Tendido de tubo adicional',
        'Colocación de microductos para fibra óptica',
        'Acometida',
        'Sistemas de canalización urbana'
      ],
      features3: [
        'Cruce de calzada mediante topo',
        'Obra civil gabinete DP',
        'Realización de punto FTTF',
        'Conexiones de red especializadas',
        'Inspección técnica especializada',
        'Gestión de emergencias 24/7'
      ],
      features4: [
        'Reposición de asfalto en acera o calzada de 2 capas',
        'Reposición de hormigón',
        'Reposición de adoquín',
        'Sellado y protección contra humedad',
        'Restauración de espacios públicos',
        'Gestión de permisos municipales'
      ]
    },
    contact: {
      title: 'Contacta con Nosotros',
      subtitle: 'Estamos aquí para ayudarte',
      form: { name: 'Nombre completo', email: 'Correo electrónico', phone: 'Teléfono', company: 'Empresa', message: 'Mensaje', send: 'Enviar Mensaje' },
      success: {
        title: 'Mensaje enviado',
        description: 'Nos pondremos en contacto contigo pronto.'
      },
      error: {
        title: 'Error',
        description: 'Hubo un problema al enviar el mensaje. Intenta nuevamente.'
      }
    },
    success: {
      title: 'Casos de Éxito',
      subtitle: 'Proyectos internacionales que demuestran nuestra experiencia y capacidad técnica en infraestructura de telecomunicaciones a gran escala',
      projectTitle: 'Telekom Deutschland GmbH - Infraestructura Alemana',
      projectSubtitle: 'Reparaciones y Tendidos de Fibra Óptica en Frankfurt y Munich',
      internationalBadge: 'PROYECTO INTERNACIONAL',
      locationsTitle: 'Ubicaciones',
      locations1: 'Frankfurt y Munich',
      locations2: 'Alemania',
      clientTitle: 'Cliente',
      clientName: 'Telekom Deutschland GmbH',
      clientDesc: 'Empresa de Telecomunicaciones',
      servicesTitle: 'Servicios',
      service1: 'Reparaciones de Red',
      service2: 'Tendidos de Fibra Óptica',
      descriptionTitle: 'Descripción del Proyecto',
      p1: 'ENAUSA fue seleccionada para ejecutar trabajos críticos de mantenimiento y expansión de infraestructura de fibra óptica en dos de las ciudades más importantes de Alemania. El proyecto incluyó reparaciones especializadas de redes existentes y nuevos tendidos para mejorar la conectividad urbana.',
      p2: 'Este proyecto internacional demuestra nuestra capacidad de adaptación a normativas europeas y nuestra experiencia en trabajos de alta complejidad técnica en entornos urbanos densos.',
      resultsTitle: 'Resultados Alcanzados',
      r1: 'Reparación exitosa de 15+ km de red de fibra óptica',
      r2: 'Instalación de nuevos tendidos en zonas de alta densidad',
      r3: 'Cumplimiento del 100% de normativas alemanas de seguridad',
      r4: 'Proyecto completado dentro del plazo establecido',
      r5: 'Certificación de calidad europea obtenida',
      r6: 'Expansión de la capacidad de red en un 40%',
      impactTitle: 'Impacto del Proyecto',
      impactQuote: 'Este proyecto nos posicionó como un socio confiable en el mercado europeo, demostrando nuestra capacidad de ejecutar trabajos de infraestructura crítica con los más altos estándares internacionales de calidad y seguridad.',
      ctaText: '¿Tienes un proyecto de infraestructura de telecomunicaciones?',
      ctaButton: 'Agendar una reunión'
    },
    footer: {
      description: 'Líderes en infraestructura de telecomunicaciones con expertise comprobada.',
      followUs: 'Síguenos',
      services: 'Servicios',
      company: 'Empresa',
      contactInfo: 'Información de Contacto',
      centralOffice: 'Oficina Central - Argentina',
      spainOffice: 'Oficina España',
      phones: 'Teléfonos',
      email: 'Email',
      hours: 'Horarios',
      mondayFriday: 'Lun - Vie: 8:00 - 18:00',
      certifications: 'Certificaciones',
      qualityStandards: 'Estándares de Calidad Certificados',
      laborSafety: 'Seguridad Laboral',
      aboutUs: 'Acerca de Nosotros',
      employment: 'Oportunidades de Empleo',
      projects: 'Nuestros Proyectos',
      privacyPolicy: 'Política de Privacidad',
      termsOfService: 'Términos de Servicio',
      copyright: '© 2024 ENAUSA Infraestructura. Todos los derechos reservados.'
    }
  },
  en: {
    nav: { home: 'Home', services: 'Services', about: 'About', employment: 'Employment', contact: 'Contact' },
    hero: {
      title: 'Cutting-Edge Telecommunications Infrastructure',
      subtitle: 'We connect the future with comprehensive solutions in canalizations, ducts and fiber optics for telecommunications networks.',
      cta: 'Schedule a Meeting',
      team: 'Expert Team',
      teamDesc: 'Specialized engineers and technicians',
      projects: 'Projects delivered on time',
      coverage: 'Countries of operation'
    },
    about: {
      title: 'About ENAUSA',
      subtitle: 'Leaders in Telecommunications Infrastructure',
      description: 'ENAUSA has established itself as a leading company in the construction and maintenance of telecommunications infrastructure in Argentina, Spain and Germany.',
      mission: 'Our Mission',
      missionText: 'To provide comprehensive infrastructure solutions that enable the expansion and modernization of telecommunications networks.',
      values: 'Our Values',
      valuesList: {
        one: { title: 'Guaranteed Quality', description: 'Compliance with the highest safety and hygiene standards in all our projects.' },
        two: { title: 'Proven Experience', description: 'Years of experience in large-scale telecommunications infrastructure projects.' },
        three: { title: 'Advanced Technology', description: 'We use state-of-the-art equipment and techniques to ensure optimal results.' },
        four: { title: 'Environmental Commitment', description: 'Strict environmental protocols to minimize impact during and after construction.' }
      },
      process: {
        title: 'Our Work Process',
        subtitle: 'A systematic and professional approach to guarantee excellence in every project',
        steps: {
          s1: { title: 'Analysis and Planning', desc: 'Topography and soil studies' },
          s2: { title: 'Permits and Coordination', desc: 'Management with municipalities and entities' },
          s3: { title: 'Construction', desc: 'Building with quality standards' },
          s4: { title: 'Quality Control', desc: 'Verification and thorough testing' },
          s5: { title: 'Maintenance', desc: 'Continuous and preventive support' }
        }
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive Telecommunications Solutions',
      infrastructure: { title: 'Trenching Infrastructure', description: 'Professional trenching and excavation for underground telecommunications ducts.' },
      installation: { title: 'Duct and Fiber Installation', description: 'Professional installation of ducts and fiber optic cabling.' },
      maintenance: { title: 'Specialized Technical Services', description: 'Advanced services for complex installations.' },
      permits: { title: 'Restoration and Reinstatement', description: 'Surface restoration after trenching and installation work.' },
      features1: [
        'Cobblestone trenching',
        'Sidewalk aggregate trenching',
        'Road aggregate trenching',
        'Earth trenching',
        'Historic pavement trenching',
        'Underground duct trenching',
        'Inspection chamber installation'
      ],
      features2: [
        'High-capacity duct installation',
        'Fiber optic cable laying',
        'Additional conduit laying',
        'Fiber optic microduct placement',
        'Service connections',
        'Urban conduit systems'
      ],
      features3: [
        'Road crossing by mole',
        'DP cabinet civil works',
        'FTTF point implementation',
        'Specialized network connections',
        'Specialized technical inspection',
        '24/7 emergency management'
      ],
      features4: [
        '2-layer asphalt reinstatement on sidewalk or roadway',
        'Concrete reinstatement',
        'Cobblestone reinstatement',
        'Moisture sealing and protection',
        'Public space restoration',
        'Municipal permit management'
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to help you',
      form: { name: 'Full name', email: 'Email address', phone: 'Phone', company: 'Company', message: 'Message', send: 'Send Message' },
      success: {
        title: 'Message sent',
        description: 'We will get in touch with you soon.'
      },
      error: {
        title: 'Error',
        description: 'There was a problem sending the message. Please try again.'
      }
    },
    success: {
      title: 'Success Stories',
      subtitle: 'International projects that demonstrate our experience and technical capacity in large-scale telecommunications infrastructure',
      projectTitle: 'Telekom Deutschland GmbH - German Infrastructure',
      projectSubtitle: 'Fiber Optic Repairs and Deployments in Frankfurt and Munich',
      internationalBadge: 'INTERNATIONAL PROJECT',
      locationsTitle: 'Locations',
      locations1: 'Frankfurt and Munich',
      locations2: 'Germany',
      clientTitle: 'Client',
      clientName: 'Telekom Deutschland GmbH',
      clientDesc: 'Telecommunications Company',
      servicesTitle: 'Services',
      service1: 'Network Repairs',
      service2: 'Fiber Optic Deployments',
      descriptionTitle: 'Project Description',
      p1: 'ENAUSA was selected to carry out critical maintenance and expansion work on fiber optic infrastructure in two of Germany’s most important cities. The project included specialized repairs of existing networks and new deployments to improve urban connectivity.',
      p2: 'This international project demonstrates our ability to adapt to European regulations and our experience in high technical complexity work in dense urban environments.',
      resultsTitle: 'Results Achieved',
      r1: 'Successful repair of 15+ km of fiber optic network',
      r2: 'Installation of new deployments in high-density areas',
      r3: '100% compliance with German safety regulations',
      r4: 'Project completed within the established timeframe',
      r5: 'European quality certification obtained',
      r6: 'Network capacity expanded by 40%',
      impactTitle: 'Project Impact',
      impactQuote: 'This project positioned us as a reliable partner in the European market, demonstrating our ability to execute critical infrastructure work with the highest international standards of quality and safety.',
      ctaText: 'Do you have a telecommunications infrastructure project?',
      ctaButton: 'Schedule a Meeting'
    },
    footer: {
      description: 'Leaders in telecommunications infrastructure with proven expertise.',
      followUs: 'Follow Us',
      services: 'Services',
      company: 'Company',
      contactInfo: 'Contact Information',
      centralOffice: 'Central Office - Argentina',
      spainOffice: 'Spain Office',
      phones: 'Phones',
      email: 'Email',
      hours: 'Hours',
      mondayFriday: 'Mon - Fri: 8:00 - 18:00',
      certifications: 'Certifications',
      qualityStandards: 'Certified Quality Standards',
      laborSafety: 'Labor Safety',
      aboutUs: 'About Us',
      employment: 'Employment Opportunities',
      projects: 'Our Projects',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      copyright: '© 2024 ENAUSA Infrastructure. All rights reserved.'
    }
  },
  de: {
    nav: { home: 'Startseite', services: 'Dienstleistungen', about: 'Über uns', employment: 'Beschäftigung', contact: 'Kontakt' },
    hero: {
      title: 'Modernste Telekommunikationsinfrastruktur',
      subtitle: 'Wir verbinden die Zukunft mit umfassenden Lösungen in Kanalisationen, Rohren und Glasfaser für Telekommunikationsnetze.',
      cta: 'Termin vereinbaren',
      team: 'Expertenteam',
      teamDesc: 'Spezialisierte Ingenieure und Techniker',
      projects: 'Projekte pünktlich geliefert',
      coverage: 'Länder der Tätigkeit'
    },
    about: {
      title: 'Über ENAUSA',
      subtitle: 'Führend in der Telekommunikationsinfrastruktur',
      description: 'ENAUSA ist ein führendes Unternehmen im Bau und in der Wartung von Telekommunikationsinfrastruktur in Argentinien, Spanien und Deutschland.',
      mission: 'Unsere Mission',
      missionText: 'Bereitstellung umfassender Infrastrukturlösungen zur Erweiterung und Modernisierung von Telekommunikationsnetzen.',
      values: 'Unsere Werte',
      valuesList: {
        one: { title: 'Garantierte Qualität', description: 'Einhaltung der höchsten Sicherheits- und Hygienestandards in all unseren Projekten.' },
        two: { title: 'Bewährte Erfahrung', description: 'Jahrelange Erfahrung in groß angelegten Telekommunikationsinfrastrukturprojekten.' },
        three: { title: 'Fortschrittliche Technologie', description: 'Wir verwenden modernste Geräte und Techniken, um optimale Ergebnisse zu gewährleisten.' },
        four: { title: 'Umweltengagement', description: 'Strenge Umweltprotokolle zur Minimierung der Auswirkungen während und nach der Bauphase.' }
      },
      process: {
        title: 'Unser Arbeitsprozess',
        subtitle: 'Ein systematischer und professioneller Ansatz, um Exzellenz in jedem Projekt zu gewährleisten',
        steps: {
          s1: { title: 'Analyse und Planung', desc: 'Topographie und Bodenuntersuchungen' },
          s2: { title: 'Genehmigungen und Koordination', desc: 'Verwaltung mit Gemeinden und Behörden' },
          s3: { title: 'Ausführung der Arbeiten', desc: 'Bau nach Qualitätsstandards' },
          s4: { title: 'Qualitätskontrolle', desc: 'Überprüfung und gründliche Tests' },
          s5: { title: 'Wartung', desc: 'Kontinuierliche und präventive Unterstützung' }
        }
      }
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Umfassende Telekommunikationslösungen',
      infrastructure: { title: 'Kanalisationsinfrastruktur', description: 'Aushub und Graben für unterirdische Leitungen.' },
      installation: { title: 'Rohr- und Glasfaserinstallation', description: 'Professionelle Installation von Rohren und Glasfaserverkabelung.' },
      maintenance: { title: 'Spezialisierte technische Dienste', description: 'Erweiterte Dienste für komplexe Installationen.' },
      permits: { title: 'Wiederherstellung und Instandsetzung', description: 'Oberflächenwiederherstellung nach Installationsarbeiten.' },
      features1: [
        'Kopfsteinpflaster-Graben',
        'Bürgersteig-Aggregat-Graben',
        'Straßen-Aggregat-Graben',
        'Erdgraben',
        'Historisches Pflaster-Graben',
        'Unterirdische Kanalgraben',
        'Installation von Inspektionskammern'
      ],
      features2: [
        'Installation von Hochkapazitätsrohren',
        'Verlegung von Glasfaserkabeln',
        'Zusätzliche Rohrverlegung',
        'Platzierung von Glasfaser-Mikrorohren',
        'Hausanschlüsse',
        'Städtische Kanalisationssysteme'
      ],
      features3: [
        'Straßenkreuzung durch Maulwurf',
        'DP-Schrank Tiefbau',
        'FTTF-Punkt Umsetzung',
        'Spezialisierte Netzwerkverbindungen',
        'Spezialisierte technische Inspektion',
        '24/7 Notfallmanagement'
      ],
      features4: [
        '2-Schicht Asphalt-Wiederherstellung auf Bürgersteig oder Fahrbahn',
        'Beton-Wiederherstellung',
        'Kopfsteinpflaster-Wiederherstellung',
        'Feuchtigkeitsabdichtung und -schutz',
        'Wiederherstellung öffentlicher Räume',
        'Verwaltung kommunaler Genehmigungen'
      ]
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir sind hier, um Ihnen zu helfen',
      form: { name: 'Vollständiger Name', email: 'E-Mail-Adresse', phone: 'Telefon', company: 'Unternehmen', message: 'Nachricht', send: 'Nachricht senden' },
      success: {
        title: 'Nachricht gesendet',
        description: 'Wir werden uns bald mit Ihnen in Verbindung setzen.'
      },
      error: {
        title: 'Fehler',
        description: 'Es gab ein Problem beim Senden der Nachricht. Bitte versuchen Sie es erneut.'
      }
    },
    success: {
      title: 'Erfolgsgeschichten',
      subtitle: 'Internationale Projekte, die unsere Erfahrung und technische Fähigkeit in groß angelegter Telekommunikationsinfrastruktur demonstrieren',
      projectTitle: 'Telekom Deutschland GmbH - Deutsche Infrastruktur',
      projectSubtitle: 'Glasfaserreparaturen und -verlegungen in Frankfurt und München',
      internationalBadge: 'INTERNATIONALES PROJEKT',
      locationsTitle: 'Standorte',
      locations1: 'Frankfurt und München',
      locations2: 'Deutschland',
      clientTitle: 'Kunde',
      clientName: 'Telekom Deutschland GmbH',
      clientDesc: 'Telekommunikationsunternehmen',
      servicesTitle: 'Dienstleistungen',
      service1: 'Netzreparaturen',
      service2: 'Glasfaserverlegungen',
      descriptionTitle: 'Projektbeschreibung',
      p1: 'ENAUSA wurde ausgewählt, um kritische Wartungs- und Erweiterungsarbeiten an der Glasfaserinfrastruktur in zwei der wichtigsten Städte Deutschlands durchzuführen. Das Projekt umfasste spezielle Reparaturen bestehender Netze und neue Verlegungen zur Verbesserung der städtischen Konnektivität.',
      p2: 'Dieses internationale Projekt zeigt unsere Fähigkeit, sich an europäische Vorschriften anzupassen, und unsere Erfahrung in technisch hochkomplexen Arbeiten in dicht besiedelten städtischen Umgebungen.',
      resultsTitle: 'Erzielte Ergebnisse',
      r1: 'Erfolgreiche Reparatur von über 15 km Glasfasernetz',
      r2: 'Installation neuer Verlegungen in hochdichten Bereichen',
      r3: '100%ige Einhaltung der deutschen Sicherheitsvorschriften',
      r4: 'Projekt innerhalb des festgelegten Zeitrahmens abgeschlossen',
      r5: 'Europäische Qualitätszertifizierung erhalten',
      r6: 'Erweiterung der Netzkapazität um 40%',
      impactTitle: 'Projektauswirkungen',
      impactQuote: 'Dieses Projekt positionierte uns als zuverlässigen Partner auf dem europäischen Markt und zeigte unsere Fähigkeit, kritische Infrastrukturarbeiten mit höchsten internationalen Standards in Qualität und Sicherheit durchzuführen.',
      ctaText: 'Haben Sie ein Telekommunikationsinfrastrukturprojekt?',
      ctaButton: 'Termin vereinbaren'
    },
    footer: {
      description: 'Führend in der Telekommunikationsinfrastruktur mit bewährter Expertise.',
      followUs: 'Folgen Sie uns',
      services: 'Dienstleistungen',
      company: 'Unternehmen',
      contactInfo: 'Kontaktinformationen',
      centralOffice: 'Zentrale - Argentinien',
      spainOffice: 'Büro Spanien',
      phones: 'Telefone',
      email: 'E-Mail',
      hours: 'Öffnungszeiten',
      mondayFriday: 'Mo - Fr: 8:00 - 18:00',
      certifications: 'Zertifizierungen',
      qualityStandards: 'Zertifizierte Qualitätsstandards',
      laborSafety: 'Arbeitssicherheit',
      aboutUs: 'Über uns',
      employment: 'Beschäftigungsmöglichkeiten',
      projects: 'Unsere Projekte',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfService: 'Nutzungsbedingungen',
      copyright: '© 2024 ENAUSA Infrastruktur. Alle Rechte vorbehalten.'
    }
  },
  nl: {
    nav: { home: 'Home', services: 'Diensten', about: 'Over ons', employment: 'Werkgelegenheid', contact: 'Contact' },
    hero: {
      title: 'Geavanceerde Telecommunicatie-infrastructuur',
      subtitle: 'We verbinden de toekomst met uitgebreide oplossingen in kanalisatie, leidingen en glasvezel voor telecommunicatienetwerken.',
      cta: 'Een meeting plannen',
      team: 'Expertteam',
      teamDesc: 'Gespecialiseerde ingenieurs en technici',
      projects: 'Projecten op tijd opgeleverd',
      coverage: 'Landen van operatie'
    },
    about: {
      title: 'Over ENAUSA',
      subtitle: 'Leiders in Telecommunicatie-infrastructuur',
      description: 'Met meer dan 15 jaar ervaring is ENAUSA een leidend bedrijf in de bouw en het onderhoud van telecommunicatie-infrastructuur in Argentinië, Spanje en Duitsland.',
      mission: 'Onze Missie',
      missionText: 'Het leveren van uitgebreide infrastructuuroplossingen die de uitbreiding en modernisering van telecommunicatienetwerken mogelijk maken.',
      values: 'Onze Waarden',
      valuesList: {
        one: { title: 'Gegarandeerde Kwaliteit', description: 'Naleving van de hoogste veiligheids- en hygiënenormen in al onze projecten.' },
        two: { title: 'Bewezen Ervaring', description: 'Jarenlange ervaring in grootschalige telecommunicatie-infrastructuurprojecten.' },
        three: { title: 'Geavanceerde Technologie', description: 'We gebruiken de nieuwste apparatuur en technieken om optimale resultaten te garanderen.' },
        four: { title: 'Milieuengagement', description: 'Strikte milieuprotocollen om de impact tijdens en na de bouw te minimaliseren.' }
      },
      process: {
        title: 'Ons Werkproces',
        subtitle: 'Een systematische en professionele benadering om uitmuntendheid in elk project te garanderen',
        steps: {
          s1: { title: 'Analyse en Planning', desc: 'Topografie en bodemonderzoek' },
          s2: { title: 'Vergunningen en Coördinatie', desc: 'Beheer met gemeenten en entiteiten' },
          s3: { title: 'Uitvoering', desc: 'Bouwen volgens kwaliteitsnormen' },
          s4: { title: 'Kwaliteitscontrole', desc: 'Verificatie en grondige testen' },
          s5: { title: 'Onderhoud', desc: 'Continue en preventieve ondersteuning' }
        }
      }
    },
    services: {
      title: 'Onze Diensten',
      subtitle: 'Uitgebreide Telecommunicatieoplossingen',
      infrastructure: { title: 'Graafwerk Infrastructuur', description: 'Professioneel graafwerk en uitgraving voor ondergrondse telecommunicatieleidingen.' },
      installation: { title: 'Leiding- en Glasvezelinstallatie', description: 'Professionele installatie van leidingen en glasvezelbekabeling.' },
      maintenance: { title: 'Gespecialiseerde Technische Diensten', description: 'Geavanceerde diensten voor complexe installaties.' },
      permits: { title: 'Herstel en Instandhouding', description: 'Oppervlakteherstel na graafwerk en installatiewerkzaamheden.' },
      features1: [
        'Klinker graafwerk',
        'Stoep aggregaat graafwerk',
        'Weg aggregaat graafwerk',
        'Aarde graafwerk',
        'Historische bestrating graafwerk',
        'Ondergrondse kanaal graafwerk',
        'Inspectiekamer installatie'
      ],
      features2: [
        'Installatie van hoge capaciteit leidingen',
        'Glasvezelkabel aanleg',
        'Aanvullende buis aanleg',
        'Glasvezel microduct plaatsing',
        'Serviceaansluitingen',
        'Stedelijke kanaalsystemen'
      ],
      features3: [
        'Wegovergang door mol',
        'DP kast civieltechnische werken',
        'FTTF punt implementatie',
        'Gespecialiseerde netwerkverbindingen',
        'Gespecialiseerde technische inspectie',
        '24/7 noodbeheer'
      ],
      features4: [
        '2-laags asfalt herstel op stoep of rijbaan',
        'Beton herstel',
        'Klinker herstel',
        'Vocht afdichting en bescherming',
        'Openbare ruimte herstel',
        'Gemeentelijke vergunning beheer'
      ]
    },
    contact: {
      title: 'Neem Contact Op',
      subtitle: 'We zijn hier om je te helpen',
      form: { name: 'Volledige naam', email: 'E-mailadres', phone: 'Telefoon', company: 'Bedrijf', message: 'Bericht', send: 'Bericht versturen' },
      success: {
        title: 'Bericht verzonden',
        description: 'We nemen binnenkort contact met je op.'
      },
      error: {
        title: 'Fout',
        description: 'Er was een probleem met het verzenden van het bericht. Probeer het opnieuw.'
      }
    },
    success: {
      title: 'Succesverhalen',
      subtitle: 'Internationale projecten die onze ervaring en technische capaciteit in grootschalige telecommunicatie-infrastructuur aantonen',
      projectTitle: 'Telekom Deutschland GmbH - Duitse Infrastructuur',
      projectSubtitle: 'Glasvezelreparaties en -aanleg in Frankfurt en München',
      internationalBadge: 'INTERNATIONAAL PROJECT',
      locationsTitle: 'Locaties',
      locations1: 'Frankfurt en München',
      locations2: 'Duitsland',
      clientTitle: 'Klant',
      clientName: 'Telekom Deutschland GmbH',
      clientDesc: 'Telecommunicatiebedrijf',
      servicesTitle: 'Diensten',
      service1: 'Netwerkreparaties',
      service2: 'Glasvezelaanleg',
      descriptionTitle: 'Projectbeschrijving',
      p1: 'ENAUSA werd geselecteerd om kritieke onderhouds- en uitbreidingswerkzaamheden uit te voeren aan glasvezelinfrastructuur in twee van de belangrijkste steden van Duitsland. Het project omvatte gespecialiseerde reparaties van bestaande netwerken en nieuwe aanleg om de stedelijke connectiviteit te verbeteren.',
      p2: 'Dit internationale project toont ons vermogen om ons aan te passen aan Europese regelgeving en onze ervaring in technisch hoogcomplexe werkzaamheden in dichtbevolkte stedelijke omgevingen.',
      resultsTitle: 'Behaalde Resultaten',
      r1: 'Succesvolle reparatie van 15+ km glasvezelnetwerk',
      r2: 'Installatie van nieuwe aanleg in dichtbevolkte gebieden',
      r3: '100% naleving van Duitse veiligheidsvoorschriften',
      r4: 'Project voltooid binnen de gestelde termijn',
      r5: 'Europese kwaliteitscertificering behaald',
      r6: 'Netwerkcapaciteit uitgebreid met 40%',
      impactTitle: 'Projectimpact',
      impactQuote: 'Dit project positioneerde ons als een betrouwbare partner op de Europese markt, en toonde ons vermogen aan om kritieke infrastructuurwerkzaamheden uit te voeren met de hoogste internationale normen voor kwaliteit en veiligheid.',
      ctaText: 'Heb je een telecommunicatie-infrastructuurproject?',
      ctaButton: 'Een meeting plannen'
    },
    footer: {
      description: 'Leiders in telecommunicatie-infrastructuur met meer dan 15 jaar ervaring.',
      followUs: 'Volg Ons',
      services: 'Diensten',
      company: 'Bedrijf',
      contactInfo: 'Contactinformatie',
      centralOffice: 'Hoofdkantoor - Argentinië',
      spainOffice: 'Kantoor Spanje',
      phones: 'Telefoons',
      email: 'E-mail',
      hours: 'Openingstijden',
      mondayFriday: 'Ma - Vr: 8:00 - 18:00',
      certifications: 'Certificeringen',
      qualityStandards: 'Gecertificeerde Kwaliteitsnormen',
      laborSafety: 'Arbeidsveiligheid',
      aboutUs: 'Over Ons',
      employment: 'Werkgelegenheidsmogelijkheden',
      projects: 'Onze Projecten',
      privacyPolicy: 'Privacybeleid',
      termsOfService: 'Servicevoorwaarden',
      copyright: '© 2024 ENAUSA Infrastructuur. Alle rechten voorbehouden.'
    }
  },
  fr: {
    nav: { home: 'Accueil', services: 'Services', about: 'À propos', employment: 'Emploi', contact: 'Contact' },
    hero: {
      title: 'Infrastructure de Télécommunications de Pointe',
      subtitle: 'Nous connectons l\'avenir avec des solutions complètes en canalisations, conduits et fibre optique pour les réseaux de télécommunications.',
      cta: 'Planifier une réunion',
      team: 'Équipe experte',
      teamDesc: 'Ingénieurs et techniciens spécialisés',
      projects: 'Projets livrés à temps',
      coverage: 'Pays d\'opération'
    },
    about: {
      title: 'À propos d\'ENAUSA',
      subtitle: 'Leaders en Infrastructure de Télécommunications',
      description: 'Avec plus de 15 ans d\'expérience, ENAUSA est une entreprise leader dans la construction et la maintenance d\'infrastructures de télécommunications en Argentine, en Espagne et en Allemagne.',
      mission: 'Notre Mission',
      missionText: 'Fournir des solutions d\'infrastructure complètes qui permettent l\'expansion et la modernisation des réseaux de télécommunications.',
      values: 'Nos Valeurs',
      valuesList: {
        one: { title: 'Qualité Garantie', description: 'Respect des plus hautes normes de sécurité et d\'hygiène dans tous nos projets.' },
        two: { title: 'Expérience Prouvée', description: 'Des années d\'expérience dans des projets d\'infrastructure de télécommunications à grande échelle.' },
        three: { title: 'Technologie Avancée', description: 'Nous utilisons des équipements et techniques de pointe pour garantir des résultats optimaux.' },
        four: { title: 'Engagement Environnemental', description: 'Protocoles environnementaux stricts pour minimiser l\'impact pendant et après la construction.' }
      },
      process: {
        title: 'Notre Processus de Travail',
        subtitle: 'Une approche systématique et professionnelle pour garantir l\'excellence dans chaque projet',
        steps: {
          s1: { title: 'Analyse et Planification', desc: 'Topographie et études de sol' },
          s2: { title: 'Permis et Coordination', desc: 'Gestion avec les municipalités et entités' },
          s3: { title: 'Exécution', desc: 'Construction selon les normes de qualité' },
          s4: { title: 'Contrôle Qualité', desc: 'Vérification et tests approfondis' },
          s5: { title: 'Maintenance', desc: 'Support continu et préventif' }
        }
      }
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Solutions de Télécommunications Complètes',
      infrastructure: { title: 'Infrastructure de Tranchage', description: 'Tranchage et excavation professionnels pour conduits de télécommunications souterrains.' },
      installation: { title: 'Installation de Conduits et Fibre', description: 'Installation professionnelle de conduits et câblage fibre optique.' },
      maintenance: { title: 'Services Techniques Spécialisés', description: 'Services avancés pour installations complexes.' },
      permits: { title: 'Restauration et Remise en État', description: 'Restauration de surface après travaux de tranchage et installation.' },
      features1: [
        'Tranchage de pavés',
        'Tranchage d\'agrégat de trottoir',
        'Tranchage d\'agrégat de chaussée',
        'Tranchage de terre',
        'Tranchage de pavé historique',
        'Tranchage de conduit souterrain',
        'Installation de chambres d\'inspection'
      ],
      features2: [
        'Installation de conduits haute capacité',
        'Pose de câbles fibre optique',
        'Pose de conduit supplémentaire',
        'Placement de micro-conduits fibre optique',
        'Branchements de service',
        'Systèmes de canalisation urbaine'
      ],
      features3: [
        'Traversée de chaussée par taupe',
        'Travaux civils armoire DP',
        'Réalisation de point FTTF',
        'Connexions réseau spécialisées',
        'Inspection technique spécialisée',
        'Gestion d\'urgence 24/7'
      ],
      features4: [
        'Remise en état d\'asphalte 2 couches sur trottoir ou chaussée',
        'Remise en état de béton',
        'Remise en état de pavés',
        'Étanchéité et protection d\'humidité',
        'Restauration d\'espaces publics',
        'Gestion de permis municipaux'
      ]
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes là pour vous aider',
      form: { name: 'Nom complet', email: 'Adresse e-mail', phone: 'Téléphone', company: 'Entreprise', message: 'Message', send: 'Envoyer le message' },
      success: {
        title: 'Message envoyé',
        description: 'Nous vous contacterons bientôt.'
      },
      error: {
        title: 'Erreur',
        description: 'Il y a eu un problème lors de l\'envoi du message. Veuillez réessayer.'
      }
    },
    success: {
      title: 'Histoires de Succès',
      subtitle: 'Projets internationaux qui démontrent notre expérience et capacité technique en infrastructure de télécommunications à grande échelle',
      projectTitle: 'Telekom Deutschland GmbH - Infrastructure Allemande',
      projectSubtitle: 'Réparations et Déploiements de Fibre Optique à Francfort et Munich',
      internationalBadge: 'PROJET INTERNATIONAL',
      locationsTitle: 'Emplacements',
      locations1: 'Francfort et Munich',
      locations2: 'Allemagne',
      clientTitle: 'Client',
      clientName: 'Telekom Deutschland GmbH',
      clientDesc: 'Entreprise de Télécommunications',
      servicesTitle: 'Services',
      service1: 'Réparations de Réseau',
      service2: 'Déploiements de Fibre Optique',
      descriptionTitle: 'Description du Projet',
      p1: 'ENAUSA a été sélectionnée pour effectuer des travaux critiques de maintenance et d\'expansion de l\'infrastructure fibre optique dans deux des villes les plus importantes d\'Allemagne. Le projet comprenait des réparations spécialisées de réseaux existants et de nouveaux déploiements pour améliorer la connectivité urbaine.',
      p2: 'Ce projet international démontre notre capacité à nous adapter aux réglementations européennes et notre expérience dans des travaux de haute complexité technique en environnements urbains denses.',
      resultsTitle: 'Résultats Obtenus',
      r1: 'Réparation réussie de plus de 15 km de réseau fibre optique',
      r2: 'Installation de nouveaux déploiements dans des zones à haute densité',
      r3: 'Conformité à 100% avec les réglementations de sécurité allemandes',
      r4: 'Projet terminé dans les délais établis',
      r5: 'Certification de qualité européenne obtenue',
      r6: 'Capacité du réseau élargie de 40%',
      impactTitle: 'Impact du Projet',
      impactQuote: 'Ce projet nous a positionnés comme un partenaire fiable sur le marché européen, démontrant notre capacité à exécuter des travaux d\'infrastructure critiques avec les plus hauts standards internationaux de qualité et sécurité.',
      ctaText: 'Avez-vous un projet d\'infrastructure de télécommunications?',
      ctaButton: 'Planifier une réunion'
    },
    footer: {
      description: 'Leaders en infrastructure de télécommunications avec plus de 15 ans d\'expérience.',
      followUs: 'Suivez-nous',
      services: 'Services',
      company: 'Entreprise',
      contactInfo: 'Informations de Contact',
      centralOffice: 'Bureau Central - Argentine',
      spainOffice: 'Bureau Espagne',
      phones: 'Téléphones',
      email: 'E-mail',
      hours: 'Horaires',
      mondayFriday: 'Lun - Ven: 8:00 - 18:00',
      certifications: 'Certifications',
      qualityStandards: 'Normes de Qualité Certifiées',
      laborSafety: 'Sécurité du Travail',
      aboutUs: 'À Propos de Nous',
      employment: 'Opportunités d\'Emploi',
      projects: 'Nos Projets',
      privacyPolicy: 'Politique de Confidentialité',
      termsOfService: 'Conditions de Service',
      copyright: '© 2024 ENAUSA Infrastructure. Tous droits réservés.'
    }
  }
};